var language = angular.module('language', ['classy', 'authService']);